import { ProfileApi } from 'api/ApiHelper';
import { profileQueryKey } from 'queries/profile/queryKey';
import { useQuery } from '@tanstack/react-query';

export const useGetMyProfilesQuery = () =>
  useQuery({
    queryKey: profileQueryKey.profiles,
    queryFn: () => ProfileApi.getMyProfiles(),
    gcTime: 1000 * 60 * 60 * 24,
    staleTime: 1000 * 60 * 50,
    refetchInterval: 1000 * 60 * 30,
  });
